import { render, staticRenderFns } from "./label.vue?vue&type=template&id=0999686e&scoped=true&"
import script from "./label.vue?vue&type=script&lang=js&"
export * from "./label.vue?vue&type=script&lang=js&"
import style0 from "./label.vue?vue&type=style&index=0&id=0999686e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0999686e",
  null
  
)

export default component.exports